export function Icon({
  name,
}: {
  name: "search" | "explore" | "save" | "arrow" | "play" | "filters";
}) {
  const paths = {
    search: (
      <>
        <circle cx="10.5" cy="10.5" r="6.5" />
        <path d="m16 16 4 4" />
      </>
    ),
    explore: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="m16 8-2.5 5.5L8 16l2.5-5.5Z" />
      </>
    ),
    save: <path d="M6 4h12v17l-6-4-6 4Z" />,
    arrow: <path d="M5 12h14m-5-5 5 5-5 5" />,
    play: <path d="m9 5 11 7-11 7Z" />,
    filters: (
      <>
        <path d="M3 7h18M3 17h18" />
        <circle cx="8" cy="7" r="2" />
        <circle cx="16" cy="17" r="2" />
      </>
    ),
  };
  return (
    <svg
      className="ui-icon"
      width="22"
      height="22"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths[name]}
    </svg>
  );
}
